export default "__VITE_ASSET__a4d477d5__"